/* eslint-disable no-shadow */
import axios from 'axios';

const state = {
  form: {},
  formId: '',
  test2: 'test',
  confirmed: false,
  prodDomain: 'https://forms.marketing360.com',
  prod2Domain: 'https://app.marketing360.com',
  stageDomain: 'https://stage.marketing360.com',
  qaDomain: 'https://qa.marketing360.com',
  submitted: false,
  submissionError: '',
  csrf: ''
};

const mutations = {
  setFormId(state, id) {
    state.formId = id;
  },
  addForm(state, form) {
    state.form = form;
  },
  setConfirmed(state) {
    state.confirmed = true;
  },
  setSubmitted(state, payload) {
    state.submitted = payload ? true : false;
  },
  setSubmissionError(state, error) {
    state.submissionError = error;
  },
  setCsrf(state, csrf) {
    state.csrf = csrf;
  }
};

const getters = {
  domain: (state) => {
    if (process.env.NODE_ENV == 'stage') {
      return state.stageDomain;
    }
    if (process.env.NODE_ENV == 'qa') {
      return state.qaDomain;
    }
    if (process.env.NODE_ENV == 'production') {
      if (window.location.hostname == 'app.marketing360.com') {
        return state.prod2Domain;
      }
      return state.prodDomain;
    }

    throw new TypeError('Environment is invalid', 'form.js');
  },
  formId: state => state.formId,
  fields: state => state.form.fields,
  integrationFormType: state => state.form.integrationFormType,
  fieldById: state => id => state.form.fields.find(field => field.id === id),
  fieldByType: state => type => state.form.fields.find(field => field.type === type),
  fieldByIntegration: state => integration => state.form.fields.find(field => field.integration === integration),
  // this is specifically == instead of === because sometimes the integration_field_id
  // is an int and sometimes a string in the datastore
  fieldByIntegrationFieldId: state => integrationFieldId => state.form.fields.find(field => field.integration_field_id == integrationFieldId),
  getValueByIntegrationFieldId: () => function(integrationFieldId) {
    const field = this.fieldByIntegrationFieldId(integrationFieldId);

    if (field && field.id && field.id in this.$store.getters.response) {
       return this.$store.getters.response[field.id].value || '';
    }

    return '';
  },
  redirect: state => state.form.redirect,
  inline_title: state => state.form.inline_title,
  inline_message: state => state.form.inline_message,
  nameFields: (state, getters) => {
      let name = getters.fields.filter(field => field.name == 'name');
      if (name.length == 1) {
          return name;
      } else {
          name = [];
          getters.fields.forEach(field => {
              if (field.name == 'firstName') {
                  name.unshift(field);
              } else if (field.name == 'lastName') {
                  name.push(field);
              }
          });
      }
      return [];
  },
  nameFieldIds: (state, getters) => {
      return getters.nameFields.map(field => field.id);
  },
  submit_text: state => state.form.submitText ? state.form.submitText : 'Submit',
  submissionError: state => state.submissionError,
  csrf: state => state.csrf,
  validateCaptcha: state => state.form.useCaptcha ? true : false
};

const actions = {
  async getForm({ state, commit }, { sig, domain }) {
    try {
      let endpoint = `${domain}/forms/api/v1/forms/${state.formId}?simple=1`;
      let response = await axios.get(endpoint, {
        params: {
          _sig : sig
        }
      });

      if (response.data.product && !response.data.integration) {
          response.data.integration = response.data.product;
      }

      if (response.data.productFormType && !response.data.integrationFormType) {
          response.data.integrationFormType = response.data.productFormType;
      }
      commit('addForm', response.data);

      return response.data;
    } catch (error) {
        // Can't have an empty block
        return error.response.data;
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
